export default __webpack_public_path__ + "img/WF_NOMA.3930ca62361b82cdedc5aded0e86d00c.jpg";